{
  "meta": {
    "title": "Campañas publicitarias",
    "manageAndTrack": "Gestione campañas publicitarias y haga seguimiento de su rendimiento"
  },
  "actions": {
    "addCampaign": "Agregar campaña",
    "view": "Ver",
    "edit": "Editar",
    "cancel": "Cancelar",
    "createCampaign": "Crear campaña",
    "creating": "Creando...",
    "payForCampaign": "Pagar campaña",
    "paying": "Pagando...",
    "actions": "Acciones"
  },
  "filters": {
    "statusRunning": "En curso",
    "statusEnded": "Finalizada",
    "allStatuses": "Todos los estados"
  },
  "status": {
    "DRAFT": "Borrador",
    "PENDING_PAYMENT": "Pendiente de pago",
    "PENDING_APPROVAL": "Pendiente de aprobación",
    "REJECTED": "Rechazada",
    "ACTIVE": "En curso",
    "PAUSED": "Pausada",
    "ENDED": "Finalizada",
    "CANCELLED": "Cancelada"
  },
  "lifecycle": {
    "created": "Creada",
    "paid": "Pagada",
    "approved": "Aprobada",
    "live": "Activa",
    "ended": "Finalizada"
  },
  "table": {
    "image": "Imagen",
    "name": "Campaña",
    "service": "Servicio",
    "plan": "Plan",
    "status": "Estado",
    "na": "N/D",
    "searchPlaceholder": "Buscar campañas...",
    "emptyTitle": "Sin campañas",
    "emptyDescription": "Cree una campaña para comenzar a promocionar sus servicios."
  },
  "create": {
    "title": "Crear campaña publicitaria",
    "description": "Cree una nueva campaña para promocionar sus servicios",
    "cardTitle": "Información de la campaña",
    "cardDescription": "Agregue el creativo de la campaña, seleccione un servicio, plan y fecha de inicio",
    "nameLabel": "Nombre de la campaña",
    "namePlaceholder": "Nombre para mostrar (opcional)",
    "creativeLabel": "Creativo de la campaña",
    "creativeHelp": "Suba su propia imagen o video, o genere uno con IA",
    "creativeTabs": {
      "upload": "Subir desde el dispositivo",
      "generate": "Generar con IA"
    },
    "uploadFromDeviceHelp": "Use su propia imagen o video MP4 — no se requieren créditos de IA.",
    "uploadCreativeLabel": "Creativo de la campaña",
    "uploadCreativeHelp": "Suba un PNG o JPG (hasta 3 MB) o un video MP4 (hasta 8 MB). Se recomienda relación 16:9.",
    "uploadPosterLabel": "Imagen de póster",
    "uploadPosterHelp": "Imagen fija que se muestra antes de cargar el video y en los listados.",
    "uploading": "Subiendo...",
    "serviceLabel": "Servicio",
    "serviceHelp": "Seleccione el servicio que promocionará esta campaña",
    "servicePlaceholder": "Seleccionar un servicio",
    "startDateLabel": "Fecha de inicio",
    "startDateHelp": "¿Cuándo debe comenzar a mostrarse la campaña?",
    "adPlanLabel": "Plan publicitario",
    "adPlanHelp": "Seleccione el plan de publicidad",
    "adPlanPlaceholder": "Seleccionar un plan",
    "next": "Siguiente",
    "back": "Atrás",
    "postCreatePayHint": "Campaña creada. Páguela para enviarla a aprobación.",
    "steps": {
      "creative": "Creativo",
      "service": "Servicio y plan",
      "review": "Revisión"
    },
    "errors": {
      "waitUpload": "Espere a que termine la carga",
      "uploadFailed": "Error al subir",
      "imageRequired": "La imagen de la campaña es obligatoria",
      "videoRequired": "El video de la campaña es obligatorio",
      "posterRequired": "La imagen de póster es obligatoria para anuncios en video",
      "selectService": "Seleccione un servicio",
      "selectPlan": "Seleccione un plan publicitario",
      "startDateRequired": "La fecha de inicio es obligatoria",
      "selectBusiness": "Seleccione un negocio para esta campaña",
      "createFailed": "Error al crear la campaña"
    },
    "toasts": {
      "createdSuccess": "Campaña creada correctamente"
    },
    "uploadingProgress": "Subiendo… {{progress}} %",
    "currentCreativeLabel": "Creatividad actual",
    "currentCreativeImage": "Imagen fija lista para esta campaña.",
    "currentCreativeVideo": "Anuncio animado listo para esta campaña.",
    "removeCreative": "Quitar"
  },
  "show": {
    "title": "Detalles de la campaña",
    "notFoundTitle": "Campaña no encontrada",
    "invalidId": "ID de campaña no válido",
    "campaignNotFound": "Campaña no encontrada.",
    "backToCampaigns": "Volver a campañas",
    "description": "Revise el rendimiento y los recursos de la campaña",
    "service": "Servicio",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "creativeAlt": "Creativo de la campaña",
    "uploading": "Subiendo...",
    "rejectionReason": "Motivo del rechazo",
    "payoutStatus": "Pago",
    "payoutPaid": "Ingresos pagados al negocio",
    "metrics": {
      "views": "Visualizaciones",
      "viewsDesc": "Número de visualizaciones a lo largo del tiempo",
      "clicks": "Clics",
      "clicksDesc": "Número de clics a lo largo del tiempo",
      "ctr": "Tasa de clics"
    },
    "status": {
      "running": "En curso",
      "ended": "Finalizada",
      "awaitingApproval": "Pendiente de aprobación",
      "awaitingPayment": "Pendiente de pago"
    },
    "payment": {
      "confirmed": "Pago de campaña confirmado",
      "processing": "El pago puede estar aún en proceso. Actualice esta página en breve.",
      "failedUrl": "Error al obtener la URL de pago",
      "failedPay": "Error al pagar la campaña"
    },
    "image": {
      "updatedSuccess": "Imagen actualizada correctamente",
      "updateFailed": "Error al actualizar la imagen",
      "confirmTitle": "¿Actualizar imagen de la campaña?",
      "confirmDescription": "Cambiar la imagen restablece la aprobación. Su campaña deberá revisarse de nuevo.",
      "confirmAction": "Actualizar imagen"
    },
    "creativeUnavailable": "Creatividad no disponible"
  },
  "edit": {
    "title": "Editar campaña",
    "description": "Actualizar el creativo de la campaña",
    "detailsTitle": "Detalles de la campaña",
    "detailsDescription": "Edite nombre, calendario y plan antes del pago.",
    "saveDetails": "Guardar detalles",
    "cardTitle": "Imagen de la campaña",
    "cardDescription": "Suba una nueva imagen para su campaña (se recomienda relación 16:9)",
    "creativeLabel": "Creativo de la campaña",
    "creativeHelp": "Reemplace la imagen actual de la campaña",
    "paidDetailsHint": "Los detalles no se pueden cambiar después del pago. Aún puede reemplazar la imagen de la campaña.",
    "saveChanges": "Guardar cambios",
    "reviewDescription": "Revise sus cambios antes de guardar.",
    "toasts": {
      "updatedSuccess": "Campaña actualizada correctamente",
      "updateFailed": "Error al actualizar la campaña"
    }
  },
  "chart": {
    "selectRange": "Seleccionar rango",
    "daily": "Diario",
    "monthly": "Mensual",
    "yearly": "Anual",
    "value": "Valor"
  },
  "admin": {
    "pendingTitle": "Campañas pendientes",
    "pendingDescription": "Campañas pagadas en espera de aprobación",
    "summaryPending": "Pendientes",
    "summaryActive": "Activas",
    "summaryRevenue": "Ingresos del mes",
    "review": "Revisar",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "rejectionReasonLabel": "Motivo del rechazo",
    "auditLog": "Registro de auditoría"
  },
  "aiCredits": {
    "imageBalance": "{{count}} créditos imagen · {{price}} GHS c/u",
    "motionBalance": "{{count}} créditos motion · {{price}} GHS c/u",
    "buyImageTitle": "Comprar créditos de imagen",
    "buyMotionTitle": "Comprar créditos de motion",
    "buyImageDescription": "Los créditos de imagen se gastan al generar anuncios fijos con IA: un crédito por variante solicitada.",
    "buyMotionDescription": "Los créditos de motion se gastan al generar anuncios en movimiento con IA: un crédito por variante solicitada.",
    "quantityLabel": "Cantidad",
    "decreaseQuantity": "Disminuir cantidad",
    "increaseQuantity": "Aumentar cantidad",
    "totalCostLabel": "Total",
    "totalCost": "GHS {{total}}",
    "costBreakdown": "{{quantity}} créditos × GHS {{price}} c/u",
    "priceUnavailable": "Precio no disponible. Inténtelo de nuevo pronto.",
    "buyButton": "Pagar con Paystack",
    "buyImageCredits": "Comprar créditos imagen",
    "purchaseImageCredits": "Comprar créditos de imagen",
    "purchaseMotionCredits": "Comprar créditos de motion",
    "buyMotionCredits": "Comprar créditos motion",
    "purchaseSuccess": "Créditos añadidos a su saldo",
    "purchaseProcessing": "El pago puede seguir procesándose. Actualice pronto.",
    "purchaseFailed": "No se pudo iniciar la compra de créditos",
    "referenceLabel": "Imagen de referencia (opcional)",
    "referenceHelp": "Suba una foto de producto o logo para rediseñar o animar con IA",
    "referenceReady": "Referencia subida",
    "referenceUploadFailed": "Error al subir la referencia",
    "imagePanelTitle": "Generar anuncio estático",
    "motionPanelTitle": "Generar anuncio en motion",
    "headlineLabel": "Titular",
    "styleLabel": "Notas de estilo",
    "promptLabel": "Prompt",
    "promptHelp": "Describa el anuncio: oferta, tono y audiencia.",
    "motionPromptLabel": "Prompt de movimiento",
    "motionPromptHelp": "Describa movimiento sutil (zoom, brillo, producto).",
    "motionDefaultPrompt": "Movimiento promocional sutil, en bucle, estilo publicitario profesional",
    "motionDurationHint": "Genera un bucle MP4 silencioso de 5 segundos para el carrusel.",
    "variantCountLabel": "Variantes",
    "generateImage": "Generar con IA",
    "generateMotion": "Generar anuncio en motion",
    "generating": "Generando…",
    "generatingMotion": "Generando video…",
    "generationFailed": "Error en la generación",
    "variantAlt": "Variante {{index}}",
    "variantSelected": "Creativo seleccionado",
    "motionSelected": "Anuncio en motion seleccionado",
    "uploadSelectedFailed": "Error al guardar el creativo",
    "animateThis": "Animar esta imagen",
    "sourcePreviewAlt": "Imagen fuente para motion",
    "mediaTypeImage": "Imagen",
    "mediaTypeMotion": "Vídeo",
    "generatingHint": "Creando tus variantes. Normalmente tarda menos de un minuto.",
    "motionGeneratingHint": "Renderizando tu video. Puede tardar unos minutos: mantén esta pestaña abierta.",
    "selectVariantHint": "Elige una variante para usarla como creatividad del anuncio.",
    "selectMotionHint": "Elige una variante para usarla como anuncio animado.",
    "selectedBadge": "Seleccionada",
    "savingVariant": "Guardando…",
    "savingMotion": "Guardando video…",
    "preparingAnimate": "Preparando…",
    "sourceUnavailable": "Vista previa del origen no disponible. Genera o sube la imagen de nuevo.",
    "generationTimeout": "La generación agotó el tiempo de espera. Inténtalo de nuevo: puede tardar unos minutos."
  },
  "composer": {
    "title": "Crea tu creatividad",
    "subtitle": "Empieza con una plantilla, describe lo que quieres o sube la tuya.",
    "placeholder": "Describe el anuncio que quieres. Incluye la oferta, el tono y la audiencia.",
    "motionPlaceholder": "Describe el movimiento que quieres: zoom, brillo, movimiento del producto.",
    "generate": "Generar",
    "attach": "Añadir un archivo",
    "uploadOwn": "Subir mi propio anuncio",
    "addReference": "Añadir imagen de referencia",
    "variants": "{{count}} variante",
    "variants_other": "{{count}} variantes",
    "addDetails": "Añadir titular y estilo",
    "hideDetails": "Ocultar titular y estilo",
    "startOver": "Empezar de nuevo",
    "outOfImageCredits": "Te has quedado sin créditos de imagen. Compra más o sube tu propio anuncio.",
    "outOfMotionCredits": "Te has quedado sin créditos de animación. Compra más o sube tu propio anuncio."
  },
  "templates": {
    "productShowcase": {
      "title": "Escaparate de producto",
      "prompt": "Una toma de estudio limpia del producto sobre un pedestal con luz suave, amplio espacio para el texto de la oferta, moderno y premium.",
      "style": "Iluminación de estudio, minimal, alto contraste",
      "motionPrompt": "Un lento acercamiento al producto con una luz suave recorriendo la superficie, calmado y premium, apto para bucle."
    },
    "foodDrink": {
      "title": "Comida y bebida",
      "prompt": "Una toma cenital apetitosa del plato, ingredientes frescos alrededor, luz natural cálida, espacio arriba para un titular.",
      "style": "Cálido, apetitoso, luz natural",
      "motionPrompt": "Vapor suave que asciende y un lento desplazamiento sobre la mesa, cálido y acogedor, apto para bucle."
    },
    "flashSale": {
      "title": "Oferta flash",
      "prompt": "Un banner promocional llamativo anunciando un descuento por tiempo limitado, cifra de porcentaje grande, colores enérgicos, llamada a la acción clara.",
      "style": "Llamativo, enérgico, bloques de color",
      "motionPrompt": "Un barrido de luz rápido sobre las bolsas con un rebote sutil, enérgico y llamativo."
    },
    "beautySalon": {
      "title": "Belleza y salón",
      "prompt": "Un anuncio de belleza elegante con fondo degradado suave, estilo pulido, ambiente calmado y premium, espacio para el nombre del salón.",
      "style": "Suave, elegante, degradado pastel",
      "motionPrompt": "Un brillo suave recorriendo el cristal con un movimiento lento, calmado y elegante, apto para bucle."
    },
    "servicePromo": {
      "title": "Reservar un servicio",
      "prompt": "Un anuncio cercano que promueve una reserva online sencilla, tono confiable, espacio claro para el nombre del servicio y la llamada a la acción.",
      "style": "Limpio, cercano, profesional",
      "motionPrompt": "Una panorámica lenta sobre las herramientas con luz que cambia suavemente, estable y confiable."
    },
    "tattooStudio": {
      "title": "Tatuaje y estudio",
      "prompt": "Un anuncio de estudio cálido que muestra un trabajo cuidado en curso, luz natural sobre ladrillo visto, auténtico y acogedor, espacio para el nombre del estudio.",
      "style": "Cálido, luz natural, aire documental auténtico",
      "motionPrompt": "Un desplazamiento lento por el estudio con luz que cambia suavemente, cálido y pausado, apto para bucle."
    },
    "healthWellness": {
      "title": "Salud y bienestar",
      "prompt": "Un anuncio de bienestar calmado y premium con aire clínico limpio, acentos dorados suaves sobre fondo oscuro, amplio espacio para la oferta.",
      "style": "Premium, limpio, dorado suave sobre oscuro",
      "motionPrompt": "Una revelación lenta con finas partículas doradas y una rotación suave, calmada y premium, apta para bucle."
    },
    "logoReveal": {
      "title": "Revelación de logo",
      "prompt": "Movimiento sutil que revela la marca: un zoom suave con luz recorriendo la escena, apto para bucle, aire publicitario profesional.",
      "style": "",
      "motionPrompt": "Movimiento sutil que revela la marca: un zoom suave con luz recorriendo la escena, apto para bucle, aire publicitario profesional."
    }
  }
}
